export default "__VITE_ASSET__x59me0d1__"